@if (!props.hidden && props.template) {
<div [ngClass]="props.cssClass"
  [innerHTML]="getTemplateContent()"></div>
}